import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fire a lightweight page-view beacon on every route change.
 * Also emits a GA4 pageview event if GA4 is configured. Silent on failure.
 */
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    // Skip admin path to avoid polluting metrics
    if (path.startsWith("/admin")) return;
    const title = document.title;

    // Internal analytics beacon
    axios.post(`${API}/track`, { path, title }).catch(() => {});

    // GA4 SPA pageview
    const ga4 = window.__ASTORIA_GA4_ID__;
    if (typeof window.gtag === "function" && ga4 && ga4.indexOf("G-") === 0) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_title: title,
        page_location: window.location.href,
      });
    }
  }, [location.pathname]);
  return null;
};

export default RouteTracker;
